import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faPrint, faFileExcel, faSearch } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        factOperadores: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar la Factura?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("fact_opreadores/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarFactOperadores(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarFactOperadores(page) {
        Swal.showLoading();
        let bestado = document.getElementById('bestado').value;
        let bperiodo = document.getElementById('bperiodo').value;
        let bmunicipio = document.getElementById('bmunicipio').value;
        let boperador = document.getElementById('boperador').value;
        if (bestado == '') {
            bestado = 0;
        }
        if (bperiodo == '') {
            bperiodo = 0;
        }
        if (bmunicipio == '') {
            bmunicipio = 0;
        }
        if (boperador == '') {
            boperador = 0;
        }
        authAxios.get("fact_operadores/index/" + bestado + "/" + bperiodo + "/" + bmunicipio + "/" + boperador + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', factOperadores: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }

    generateReportOperatorByPeriod(){
        const id_year = '2022';
        const id_month = '11';
        const report_code = 1;
        const filename = "Reporte Operadores - Periodo " + id_year + id_month + ".xlsx";
        const data = { id_month: id_month, id_year: id_year, report_code: report_code };
        authAxios.post("excel_reports/generate-excel-reports", data,  {responseType: 'blob'})
        .then((response) => {
            const blob  = new Blob([response.data], {type: 'application/octet-stream'})
            // create download link for the blob
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            //trigger the download link
            link.click();
            // Cleanup the link and object URL
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
           
        })
        .catch((error) => console.error(`There was an error while downloading: ${error}`))
    }

    generateReportOperatorByPeriod2 () {
        // event.preventDefault();

        const id_year = '2022';
        const id_month = '11';
        const report_code = 1;
        const filename = "Reporte Operadores - Periodo " + id_year + id_month + ".xlsx";

        const data = { id_month: id_month, id_year: id_year, report_code: report_code };
        fetch('api/excel_reports/generar-reportes-excel', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                // Check if the response was successful
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                // Parse the response as a blob
                console.log(response)
                return response.blob();
            })
            .then(blob => {
                console.log(blob)
                // Create a download link for the blob
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                // Trigger the download link
                link.click();
                // Cleanup the link and object URL
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });

    };

    componentDidMount() {
        this.ListarFactOperadores(1);
    }
    render() {
        const { load, factOperadores, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddFactOperadorRed"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Factura</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Facturas Operadores de Red</h4>
                            <hr />
                            <div className="row">
                                <div className='col-md-12'>
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingOne">
                                                <button style={{ fontSize: 14 }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <b>FILTROS</b>
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
                                                <div className="accordion-body">
                                                    <div className='row'>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bestado">Estado Factura</label>
                                                            <select name="bestado" id="bestado"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                    <option value="">-</option>
                                                                    <option value="1">PAGADO</option>
                                                                    <option value="2">PENDIENTE DE PAGO</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bperiodo">Periodo</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" id="bperiodo" name="bperiodo" placeholder="PERIODO" min="0" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="bmunicipio">Municipio</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="bmunicipio" name="bmunicipio" placeholder="MUNICIPIO" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label htmlFor="boperador">Operador de Red</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="boperador" name="boperador" placeholder="OPERADOR DE RED" className="form-control form-control-sm" />
                                                        </div>
                                                        <div style={{ marginTop: 32 }} className="col-xl-1">
                                                            <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarFactOperadores(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className='col-xl-12'>
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">OPERADOR DE RED</th>
                                                <th className="align-middle">VALOR FACTURA</th>
                                                <th className="align-middle">PERIODO</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                factOperadores.map((itemFactOperadores) => (
                                                    <tr key={itemFactOperadores.ID_FACTURACION}>
                                                        {
                                                            (() => {
                                                                switch (itemFactOperadores.ESTADO_FACTURA) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PP</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        <td>{itemFactOperadores.DEPARTAMENTO}</td>
                                                        <td>{itemFactOperadores.MUNICIPIO}</td>
                                                        <td>{itemFactOperadores.OPERADOR}</td>
                                                        <td><b>$ </b>{currencyFormat(itemFactOperadores.VALOR_FACTURA)}</td>
                                                        <td>{itemFactOperadores.PERIODO_FACTURA}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpFactOperadoresRed/" + itemFactOperadores.ID_FACTURACION}
                                                                >
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemFactOperadores.ID_FACTURACION)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PAGADO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PP</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PENDIENTE PAGO</b></span>&nbsp;
                            <nav style={{ marginTop: 15 }} aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactOperadores(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactOperadores(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarOperador(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactOperadores(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFactOperadores(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;